<template>

  <div class="card">
    <div class="card-header">
      Resultado
    </div>
    <div class="card-body">
      <highcharts
        :options="chartOptions">
        </highcharts>
    </div>
    <div class="card-header">
      Prioridades
    </div>
    <div class="card-body">
      <highcharts
        :options="chartOptions2">
        </highcharts>
    </div>
    <div class="card-header">
      Descrição
    </div>
    <div class="card-body">
      <div v-if="meta.pattern_key === 'Retake self-assessment'">
        Não foi possível encontrar um padrão DISC com base nas respostas do candidato.
      </div>
      <div v-if="meta.pattern_key !== 'Retake self-assessment'">
        <p><strong>Tipo:</strong> {{ meta.pattern_name }}</p>
        <p><strong>Julga os outros por:</strong> {{ meta.judges_others }}</p>
        <p><strong>Influencia os outros por:</strong> {{ meta.influences_others }}</p>
        <p><strong>Valor para a organização:</strong> {{ meta.value_organization }}</p>
        <p><strong>Uso excessivo:</strong> {{ meta.overuses }}</p>
        <p><strong>Sob pressão:</strong> {{ meta.under_pressure }}</p>
        <p><strong>Medos:</strong> {{ meta.fears }}</p>
        <p><strong>Aumentaria a eficácia com mais:</strong> {{ meta.increase_effectiveness }}</p>
        <hr>
        <div v-html="meta.description.replace(/\n/g, '<br>')"></div>
      </div>
    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'QuestionnairePersonalityDiscClassic',
  components: {
    highcharts: Chart
  },
  props: [
    'meta'
  ],
  data () {
    return {
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          zoomType: 'lines'
        },
        title: {
          text: 'Graph III'
        },
        subtitle: {
          text: null
        },
        xAxis: {
          categories: ['D', 'I', 'S', 'C']
        },
        yAxis: { // Secondary yAxis
          gridLineWidth: 0,
          title: {
            text: 'Intensidade'
          },
          minorTickInterval: 4,
          minorTickLength: 0,
          minorTickWidth: 1,
          minorGridLineColor: '#000000',
          min: 0,
          max: 28,
          startOnTick: true,
          endOnTick: false,
          plotBands: [{ // mark the weekend
            color: '#FFFFFF',
            from: 0,
            to: 4,
            label: {
              text: '1',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 4,
            to: 8,
            label: {
              text: '2',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 8,
            to: 12,
            label: {
              text: '3',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FCFFC5',
            from: 12,
            to: 16,
            label: {
              text: '4',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 16,
            to: 20,
            label: {
              text: '5',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 20,
            to: 24,
            label: {
              text: '6',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 24,
            to: 28,
            label: {
              text: '7',
              align: 'right',
              x: -10
            }
          }]
        },
        tooltip: {
          shared: true
        },
        series: [{
          name: 'Intensidade',
          data: this.meta.change_intensities // [20, 11, 8, 18]
        }]
      }
    },
    chartOptions2 () {
      return {
        chart: {
          polar: true,
          margin: [0, 75, 0, 75]
        },
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        pane: {
          startAngle: -66.66,
          endAngle: (360 - 66.66)
        },
        xAxis: {
          categories: [
            'Resultados', // D
            'Ação', // DI/ID
            'Entusiasmo', // I
            'Colaboração', // IS/SI
            'Apoio', // S
            'Estabilidade', // CS/SC
            'Precisão', // C
            'Desafio' // CD/DC
          ],
          tickmarkPlacement: 'on'
        },
        yAxis: {
          min: 0,
          max: 100
        },
        series: [{
          type: 'area',
          name: 'Prioridade',
          data: this.meta.circle_percents
        }/* , {
          type: 'line',
          name: 'Line',
          data: [1, 8, 2, 7, 3, 6, 4, 5]
        } */]
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Questionnaire/QuestionnairePersonalityDiscClassic.vue